module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/link-b80df.png";